import React, { useRef, useState } from "react";

// Import Swiper styles
import story1 from "views/home/img/employestory/s1.png";
import story2 from "views/home/img/employestory/s2.png";

import story3 from "views/home/img/employestory/s3.png";
import story4 from "views/home/img/employestory/s4.png";
import playbutton from "views/home/img/videoslider/play-button.svg";
// install Swiper modules
import employeestory from "views/home/img/employestory/testimonial.png";
import { connect } from "react-redux";


class IlearnEmployeeStory extends React.Component {


  render() {
    return (
      <>
        <div className="bg-f8f8f8 lg:px-16 md:px-16 px-6 lg:py-12 md:py-12 py-8">
          <div className="flex justify-between items-center  lg:mb-8 md:mb-8 mb-6">
            <h2 className="fsize28 font-bold sm-fsize16">Hear from students enrolled for this course </h2>
          </div>

          <div>
            <div class="lg:flex md:flex ">
              <card class="w-3/5">
                <div className="relative">
                  <img
                    src={employeestory}
                    alt="employee story"
                    className="w-full employe-s-w w-full employe-s-w rounded-lg"
                  />
                  <div className="playbutton-place w-full">
                    {" "}
                    <img
                      src={playbutton}
                      alt="playbutton"
                      className="playbutton-w"
                    />
                  </div>
                </div>
              </card>

              <card class="w-2/5	 relative">
                <div className="lg:px-12 md:px-12 lg:mt-0 md:mt-0 mt-4">
                  <h1 className="font-medium emply-titile">
                    How would you describe career development opportunities at
                    ICICI?
                  </h1>
                  <p className="font-medium emply-subtext lg:mt-8 md:mt-8 mt-4">
                    “I’m most excited about the opportunity to grow at ICICI.”
                  </p>

                  <p className="empl-tagline-p font-medium lg:mt-8 md:mt-8 mt-4">
                    -- Archana Thalekar,{" "}
                    <span className="emply-tag-n">
                      Senior Software Engineer
                    </span>
                  </p>

                  <div className="story-rounded-card flex flex-wrap lg:mt-12 md:mt-12 mt-8 lg:absolute md:absolute lg:bottom-0 md:bottom-0">
                    <img src={story1} alt="story" className="mr-4" />
                    <img src={story2} alt="story" className="mr-4" />
                    <img src={story3} alt="story" className="mr-4" />
                    <img src={story4} alt="story" className="mr-4" />

                    <div className="relative">
                      <img src={story4} alt="story" />
                      <p className="storymore">5+</p>
                    </div>
                  </div>
                </div>
              </card>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default IlearnEmployeeStory;
